import icon from "images/icons/icon-private.svg?raw"
import parse from "html-react-parser"

export default function PrivateIcon() {
  return (
    <span className="svg-icon">{parse(icon)}</span>
  )
}
